import { PasswordValidationResult } from '../types';

/* eslint-disable class-methods-use-this */
export default class PasswordVerifyService {
  private isLengthValid = (value: string): boolean => value.length >= 7;

  private isMaxLengthValid = (value: string): boolean => value.length <= 40;

  private containsCapitalLetter = (value: string): boolean => {
    if (!value.length) return false;
    const format = /[A-Z]/;
    return Boolean(value.match(format));
  };

  private containsSpecialCharacter = (value: string): boolean => {
    if (!value.length) return false;
    const format = /[!@#$%&*]/;
    return Boolean(value.match(format));
  };

  private containsNumbers = (value: string): boolean => {
    if (!value.length) return false;
    const format = /[0-9]/;
    return Boolean(value.match(format));
  };

  private containsLowercaseLetter = (value: string): boolean => {
    if (!value.length) return false;
    const format = /[a-z]/;
    return Boolean(value.match(format));
  };

  private containsNoWhitespace = (value: string): boolean => {
    const format = /\s/;
    return !value.match(format);
  };

  validatePassword = (password: string): PasswordValidationResult => {
    const validations = {
      lengthValid: this.isLengthValid(password),
      maxLength: this.isMaxLengthValid(password),
      capitalLetter: this.containsCapitalLetter(password),
      lowercaseLetter: this.containsLowercaseLetter(password),
      specialCharacters: this.containsSpecialCharacter(password),
      containNumbers: this.containsNumbers(password),
      noWhitespace: this.containsNoWhitespace(password),
    };

    const isValid = Object.values(validations).every((value) => value === true);

    return {
      ...validations,
      isValid,
    };
  };
}
